import { ReactNode, useEffect } from 'react';
import { ColorRepresentation } from 'three';
import { RectAreaLightUniformsLib } from 'three-stdlib';

type Props = {
  color?: ColorRepresentation;
  intensity?: number;
  children?: ReactNode;
};

export const SceneLights = ({
  color = 0xffffff,
  intensity = 1,
  children,
}: Props) => {
  useEffect(() => {
    RectAreaLightUniformsLib.init();
  }, []);

  return (
    <>
      {children}
      {/** Front left lights */}
      <rectAreaLight
        position={[-1, 0, 20]}
        intensity={Math.PI * 5 * intensity}
        width={2}
        height={10}
        color={color}
      />
      <spotLight
        position={[-10, 0, 20]}
        intensity={Math.PI * 0.01 * intensity}
        color={color}
      />
      {/** Front right lights */}
      <rectAreaLight
        position={[1, 0, 20]}
        intensity={Math.PI * 5 * intensity}
        width={2}
        height={10}
        color={color}
      />
      <spotLight
        position={[10, 0, 20]}
        intensity={Math.PI * 0.01 * intensity}
        color={color}
      />
      {/** Back lights */}
      <spotLight
        position={[0.2, 0.1, -1]}
        intensity={Math.PI * 0.01 * intensity}
        color={color}
      />
      <spotLight
        position={[-0.2, 0.1, -1]}
        intensity={Math.PI * 0.01 * intensity}
        color={color}
      />
    </>
  );
};
